export enum PaymentStatus {
    paid = "paid", 
    unpaid = "unpaid",
    noPaymentRequired= "no_payment_required",
    refunded = "refunded",
}
